import { useEffect, useCallback } from 'react';

/**
 * Hook to handle global click events for closing popovers when clicking on krpano
 * This is especially useful for mobile devices where mouse events don't work
 */
export const useGlobalClickHandler = () => {
  const handleGlobalClick = useCallback((event: Event) => {
    const target = event.target as HTMLElement;

    // Check if click is on krpano container or canvas
    const isKrpanoContainer =
      target?.closest('[id*="krpano"]') ||
      target?.closest('.krpano') ||
      target?.tagName === 'CANVAS' ||
      target?.closest('canvas');

    if (isKrpanoContainer) {
      // Dispatch custom event to close all popovers
      const closePopoverEvent = new CustomEvent('closeAllPopovers', {
        detail: { source: 'krpano' },
      });
      document.dispatchEvent(closePopoverEvent);
    }
  }, []);

  useEffect(() => {
    // Add click event listener
    document.addEventListener('click', handleGlobalClick);
    document.addEventListener('touchstart', handleGlobalClick);

    return () => {
      document.removeEventListener('click', handleGlobalClick);
      document.removeEventListener('touchstart', handleGlobalClick);
    };
  }, [handleGlobalClick]);
};

export default useGlobalClickHandler;
